import { gql } from "@apollo/client";

export const START_SEARCH = gql`
  mutation campaignVanIntegrationBeginSearch(
    $campaignId: ID!
    $type: VanProxySearchType!
  ) {
    campaignVanIntegrationBeginSearch(campaignId: $campaignId, type: $type) {
      endpoint
      token
      tokenExpiresInSeconds
      lastUpdated
      totalCount
    }
  }
`;

export const REFRESH_SEARCH = gql`
  mutation campaignVanIntegrationForceRefreshSearch(
    $campaignId: ID!
    $type: VanProxySearchType!
  ) {
    campaignVanIntegrationForceRefreshSearch(
      campaignId: $campaignId
      type: $type
    ) {
      success
      lastUpdated
      totalCount
    }
  }
`;
